import UsersListContainer from './UsersListContainer'
import UsersList from './UsersList'
export { UsersList }
export { UsersListContainer }
export default UsersListContainer



// WEBPACK FOOTER //
// ./src/pages/UsersList/index.js